import type { Work } from "@/types";
import SectionHeading from "./SectionHeading";
import { genreTags } from "@/mocks/site";

interface GenreSectionProps {
  works: Work[];
  onPickGenre: (genre: string) => void;
}

export default function GenreSection({ works, onPickGenre }: GenreSectionProps) {
  const countOf = (genre: string) => works.filter((w) => w.genres.includes(genre)).length;

  return (
    <section id="genres" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-10">
        <SectionHeading
          eyebrow="题材导航 · 一键筛选"
          title="从题材出发，顺着兴趣找作品"
          desc="点击任意题材，作品库会自动按该题材筛选并跳转到对应位置。数字代表当前该类目下已收录的作品数量。"
          tone="secondary"
        />

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {genreTags.map((genre) => (
            <button
              key={genre}
              type="button"
              onClick={() => onPickGenre(genre)}
              className="group flex items-center justify-between gap-3 rounded-lg border border-background-200/70 bg-background-50 px-4 py-4 text-left hover:border-secondary-400 hover:bg-secondary-50 transition-colors"
            >
              <span className="flex items-center gap-3 min-w-0">
                <span className="w-10 h-10 rounded-md bg-accent-100 text-accent-600 flex items-center justify-center text-lg shrink-0">
                  <i className="ri-bookmark-3-line" aria-hidden="true"></i>
                </span>
                <span className="min-w-0">
                  <span className="block text-foreground-950 text-sm md:text-base font-medium truncate">{genre}</span>
                  <span className="block text-foreground-500 text-xs">{countOf(genre)} 部作品</span>
                </span>
              </span>
              <i
                className="ri-arrow-right-line text-foreground-300 group-hover:text-secondary-600 transition-colors shrink-0"
                aria-hidden="true"
              ></i>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}